import { Phone, MessageCircle } from "lucide-react";

const PHONE_NUMBER = "+61400000000";
const WHATSAPP_NUMBER = "61400000000";

export default function FloatingActions() {
  return (
    <>
      {/* WhatsApp — all screens. Restrained dark tile with subtle gold hairline. */}
      <a
        data-testid="floating-whatsapp-button"
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
          "Hello Sydney James, I'd like to enquire about a private chauffeur booking.",
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message on WhatsApp"
        className="fixed bottom-6 right-6 z-40 w-12 h-12 md:w-13 md:h-13 grid place-items-center bg-midnight border border-gold/40/60 text-warm-white shadow-[0_10px_30px_-15px_rgba(0,0,0,0.5)] transition-all duration-500 hover:border-gold hover:bg-surface-dark"
      >
        <MessageCircle className="w-4.5 h-4.5" strokeWidth={1.25} />
      </a>

      {/* Phone — mobile only */}
      <a
        data-testid="floating-phone-button"
        href={`tel:${PHONE_NUMBER}`}
        aria-label="Call the concierge desk"
        className="md:hidden fixed bottom-6 left-6 z-40 w-12 h-12 grid place-items-center bg-midnight border border-gold/40/60 text-warm-white shadow-[0_10px_30px_-15px_rgba(0,0,0,0.5)] transition-all duration-500 hover:border-gold hover:bg-surface-dark"
      >
        <Phone className="w-4.5 h-4.5" strokeWidth={1.25} />
      </a>
    </>
  );
}
